'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct3 from "./scala.-Product3.js";
var $p;
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.pK = null;
  this.pL = null;
  this.pM = null;
  this.pK = _1;
  this.pL = _2;
  this.pM = _3;
}
export { $c_T3 as $c_T3 };
$p = $c_T3.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T3;
/** @constructor */
function $h_T3() {
}
export { $h_T3 as $h_T3 };
$h_T3.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 3;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct3.$f_s_Product3__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-192629203), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T3) && (($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pK, x$0.pK) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pL, x$0.pL)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pM, x$0.pM))));
});
$p.o = (function() {
  return "Tuple3";
});
$p.b = (function() {
  return (((((("(" + this.pK) + ",") + this.pL) + ",") + this.pM) + ")");
});
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eN)));
}
export { $isArrayOf_T3 as $isArrayOf_T3 };
var $d_T3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T3, "scala.Tuple3", ({
  eN: 1,
  b: 1,
  c: 1,
  rW: 1,
  a: 1
}));
export { $d_T3 as $d_T3 };
